import React, { useEffect, useState } from 'react'
import { Card, DatePicker, Flex, Typography } from 'antd'
import { FinanceChart } from '../FinanceChart'
import {
  $financeChartData,
  $financeChartSummary,
  financeChartDataMounted,
} from './model'
import { useStore } from 'effector-react'
import { getNumberFormat } from '../../../../../libs/utils'
import { CMultiSelect } from '@coreui/react-pro'
import { Option } from '@coreui/react-pro/src/components/multi-select/types'
import { RangeValue } from '../TransactionsDetails/types'
import { rangePresets } from '../../../../billing/transactions/list/consts'
import { FinanceChartData } from '../types'

const MOCKS_DATA = {
  items: [
    {
      deposit: '10',
      withdrawal: '40',
      date: '2024-02-06T00:00:00+02:00',
    },
    {
      deposit: '28',
      withdrawal: '89',
      date: '2024-02-05T00:00:00+02:00',
    },
    {
      deposit: '30',
      withdrawal: '40',
      date: '2024-01-25T00:00:00+02:00',
    },
  ],
  summary: [
    {
      deposit: '30.000000000000000',
      withdrawal: '40.000000000000000',
      lossPercentage: '8.35',
    },
  ],
  total: 3,
}

type Props = {
  currenciesFromWallet: string[]
}

export const StatisticDetails: React.FC<Props> = ({ currenciesFromWallet }) => {
  const [filtersState, setFiltersState] = useState<{
    [key: string]: string | string[] | RangeValue
  }>({})

  const financeChartData = useStore($financeChartData)
  const financeChartSummary = useStore($financeChartSummary)

  const newData: FinanceChartData[] = []

  financeChartData
    .map((item) => ({
      ...item,
      deposit: item.deposit,
      withdrawal: item.withdrawal,
    }))
    .forEach((item) => {
      newData.push({
        category: 'deposit',
        date: item.date,
        value: item.deposit,
      })
      newData.push({
        category: 'withdrawal',
        date: item.date,
        value: item.withdrawal,
      })
    })

  const handleChangeCurrencies = (selected: Option[]) => {
    if (selected.length === 0) {
      const newState = { ...filtersState }
      delete newState['currency']

      setFiltersState(newState)
    } else {
      setFiltersState((prev) => ({
        ...prev,
        currency: selected.map((item) => item.value as string),
      }))
    }
  }

  useEffect(() => {
    financeChartDataMounted({
      filters: filtersState,
    })
  }, [filtersState])

  return (
    <Card>
      <Typography.Title level={3}>Statistics</Typography.Title>
      <Flex gap={16} style={{ marginBottom: '24px' }}>
        {currenciesFromWallet && (
          <CMultiSelect
            className="w-50"
            style={{ width: '235px' }}
            virtualScroller
            placeholder="Currency"
            size="sm"
            options={currenciesFromWallet.map((item) => ({
              text: item,
              value: item,
            }))}
            onChange={handleChangeCurrencies}
          />
        )}
        <DatePicker.RangePicker
          format="YYYY-MM-DD"
          style={{ width: '270px' }}
          value={filtersState.period as any}
          onChange={(e) => {
            const result = e ? [e] : []

            setFiltersState((prevState) => ({
              ...prevState,
              period: result[0],
            }))
          }}
          presets={rangePresets}
          allowEmpty={[true, true]}
        />
      </Flex>
      <Flex gap={24}>
        <Flex vertical>
          <Typography.Text type="success" style={{ fontSize: '18px' }}>
            Deposit
          </Typography.Text>
          <Typography.Text style={{ fontSize: '18px' }}>
            {`- ${getNumberFormat(financeChartSummary.deposit, 2)}`}
          </Typography.Text>
        </Flex>
        <Flex vertical>
          <Typography.Text type="danger" style={{ fontSize: '18px' }}>
            Withdrawal
          </Typography.Text>
          <Typography.Text style={{ fontSize: '18px' }}>
            {`- ${getNumberFormat(financeChartSummary.withdrawal, 2)}`}
          </Typography.Text>
        </Flex>
        <Flex vertical>
          <Typography.Text type="success" style={{ fontSize: '18px' }}>
            Loss
          </Typography.Text>
          <Typography.Text style={{ fontSize: '18px' }}>
            {`- ${getNumberFormat(financeChartSummary.lossPercentage, 0)}%`}
          </Typography.Text>
        </Flex>
      </Flex>
      {newData.length !== 0 && <FinanceChart data={newData} />}
    </Card>
  )
}
